import { apiPOST } from '../../lib/api'

export type BusDriverSignInResponse = {
  result: string
  timestamp: string
}

export const busDriverSignIn = async (
  tagId: string,
  timestamp: string
): Promise<BusDriverSignInResponse> => {
  return apiPOST<BusDriverSignInResponse>('/bus-driver/sign-in', {
    tagId,
    timestamp,
  })
}
